import { Vessel } from '@navstation-portal/vessels/data-model/vessel';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { VESSELS_STORE_ID } from './constants';

export const vesselsEvents = eventGroup({
  source: VESSELS_STORE_ID,
  events: {
    fetchVessels: type<string>(),
    fetchVesselsSuccess: type<Vessel[]>(),
    fetchVesselsFailed: type<Error>(),
    clearVessels: type<void>(),
  },
});
